<!-- eslint-disable vue/no-mutating-props -->
<template>
  <TransitionRoot v-if="open" as="template" :show="open">
    <Dialog as="div" class="relative z-50" @close="emit('hideModal')">
      <TransitionChild
        as="template"
        enter="ease-out duration-300"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="ease-in duration-200"
        leave-from="opacity-100"
        leave-to="opacity-0">
        <div class="fixed inset-0 bg-quinary/75 transition-opacity" />
      </TransitionChild>
      <div class="fixed inset-0 z-10 overflow-y-auto bg-black/40">
        <div class="flex min-h-full items-end justify-center p-4 text-center lg:items-center lg:p-0">
          <TransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 lg:translate-y-0 lg:scale-95"
            enter-to="opacity-100 translate-y-0 lg:scale-100"
            leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 lg:scale-100"
            leave-to="opacity-0 translate-y-4 lg:translate-y-0 lg:scale-95">
            <DialogPanel
              class="fixed top-72 lg:top-20 lg:relative transform overflow-hidden rounded-lg bg-background text-left shadow-xl transition-all lg:my-8 lg:w-full lg:max-w-2xl">
              <div class="bg-background px-4 pt-5 pb-4 lg:p-6 lg:pb-4">
                <div class="lg:flex lg:items-start">
                  <div
                    class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 lg:mx-0 lg:h-10 lg:w-10">
                    <ExclamationTriangleIcon class="h-6 w-6 text-red-600" aria-hidden="true" />
                  </div>
                  <div class="mt-3 text-center lg:mt-0 lg:ml-4 lg:text-left w-full grow">
                    <DialogTitle as="h3" class="text-base font-semibold leading-6 text-gray-900">
                      Currency change
                    </DialogTitle>
                    <div class="mt-2 flex flex-col gap-4">
                      Please note, this is a calculation function only. Payments will always be in euros, and the actual
                      amount may slightly vary from these calculations.
                    </div>
                  </div>
                </div>
              </div>
              <div class="bg-gray-50 px-4 py-3 lg:flex lg:flex-row-reverse lg:px-6">
                <button
                  type="button"
                  class="inline-flex w-full justify-center rounded-md bg-primary px-3 py-2 text-base font-semibold text-septenary shadow-sm hover:bg-primary lg:ml-3 lg:w-auto"
                  @click="selectCurrency">
                  Continue in {{ currency }}
                </button>
                <button
                  type="button"
                  class="inline-flex w-full float-left justify-center rounded-md bg-gray-200 px-3 py-2 text-base font-semibold text-septenary shadow-sm hover:bg-primary lg:ml-3 lg:w-auto"
                  @click="emit('hideModal')">
                  Cancel
                </button>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup>
import { watch } from "vue";

const props = defineProps(["open", "currency"]);

import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from "@headlessui/vue";
import { ExclamationTriangleIcon } from "@heroicons/vue/24/outline";
import { DistributorsApi } from "@xs2event/js-lib/api";
import { useUserStore } from "@/store/user";

const emit = defineEmits(["hideModal"]);
const userStore = useUserStore();

const distributorsApi = new DistributorsApi();

const selectCurrency = async () => {
  localStorage.fxRate = props.currency;
  // Currency logging
  await distributorsApi.distributorcurrencychangePost({
    distributorId: userStore.distributor_id,
    distributorCurrencyChangeRequest: { preferredCurrency: props.currency },
  });
  setTimeout(() => window.location.reload());
};

watch(
  () => props.open,
  (n) => {
    if (!n) {
      emit("hideModal");
    }
  }
);
</script>
